import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStockbank,
  processOrder,
} from "../../redux/orders/actions/orders.actions";
import styled from "./Instruction.module.scss";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { constructOrderDate } from "../../helper/DateFormatter";
import { SyncOutlined } from "@ant-design/icons";
import axiosClient from "../../service/axios";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import Reason from "../modalInstruction/Reason";
import DeclineFlag from "../modalInstruction/DeclineFlag";

const StockItems = ({ name, address, tym }) => {
  const { id } = useParams();
  const location = useLocation();
  const { title } = location.state || {};

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [reason, setReason] = React.useState(false);
  const [flag, setFlag] = React.useState(false);
  //   console.log("data", data);
  const { labxOrders, stockbankProducts } = useSelector(
    (state) => state.orderReducer
  );

  const declineHandler = async () => {
    setLoading(true);
    try {
      const response = await axiosClient.get(
        "/lite/v2/api/v3/vendor/declines/orders",
        {
          headers: {
            Authorization:
              "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiMSIsInVzZXJuYW1lIjpudWxsfQ.TYI7JaRzaX3IpuOtMbtap2oe1ilq-aBnjnR8O2PJifA",
          },
        }
      );

      const responseData = response?.data?.data;
      // console.log(responseData, "response");
      setData(responseData);
      setLoading(false);
    } catch (error) {
      console.log("error is decline");
    }
  };

  useEffect(() => {
    declineHandler();
  }, []);

  useEffect(() => {
    setReason(true);
  }, []);

  // console.log("stockbankProducts", stockbankProducts);

  let nerve = labxOrders?.nerve;

  //   console.log("nerve",nerve)

  useEffect(() => {
    dispatch(fetchStockbank(id));
  }, [dispatch, id]);

  //   const getOrderFromID = () => {
  //     let order;

  //     let match = nerve?.find((o) => o.order_id === id);
  //     if (match) {
  //       order = match;
  //     }

  //     return order;
  //   };

  //   let detail = getOrderFromID();
  //   console.log("nerve", detail)


  const color = () => {
    if (title === "StockBank") return "#78A55A";
    if (title === "Quip") return "#c7460f";
    return "#F0FDE0";
  };

  // function delay(ms) {
  //   return new Promise((resolve) => {
  //     setTimeout(resolve, ms);
  //   });
  // }

  const processHandler = async () => {
    const data ={
      id,
      title
    }
    try {
      setLoading(true);
      const res = await axiosClient.post(
        `lite/v2/api/admin/failOrder/passtoOPS`, data
      );
      if (res.status === 200) {
        setLoading(false);
        // successAlert();
        setFlag(true);
        // failToast();
        // delay(2000);
        // navigate("/failed-bids");
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  return (
    <>
      <div className="mt-3 mb-5">
        <div className={` d-flex flex-column justify-content-center`}>
          <div className="d-flex justify-content-between mt-3 mb-3">
            <p className={styled.header} style={{ color: color() }}>
              ORDER DETAILS{" | "}
              <span>{`SBO ${id}`}</span>
            </p>
            <p
              // className={styled.name}
              style={{
                // background: bgColor(),
                color: color(),
                textTransform: "uppercase",
              }}
            >
              <IoArrowBackCircleSharp size={30} onClick={() => navigate(-1)} />
              {/* {data?.title} */}
            </p>
          </div>
          <div style={{ maxHeight: "65vh", overflowY: "scroll" }}>
            <div className={styled.modalContainer2}>
              <p className={styled.title}>item(s)</p>
              <p className={styled.title}>QUANTITY</p>
              <p className={styled.title}>Brand</p>
              <p className={styled.title}>type</p>
            </div>

            <div className={styled.stockContainer}>
              {stockbankProducts?.map((p, index) => (
                <div key={index} className={styled.stock}>
                  <p className={styled.title}>{p.products_name}</p>
                  <div className={styled.line}></div>
                  <p className={styled.title}>{p.quantity}</p>
                  <div className={styled.line}></div>
                  <p className={styled.title}>{p.brand ? p.brand : "N/A"}</p>
                  <div className={styled.content}></div>
                  <p className={styled.content}>
                    {p.quantitytype ? p.quantitytype : "N/A"}
                  </p>
                </div>
              ))}
            </div>
            <div className={`${styled.modalContainer1} mt-4`}>
              <p className={styled.title}>total product count</p>
              <div className={styled.line}></div>
              <p className={styled.content}>{stockbankProducts.length}</p>
            </div>
            {data.map((item, index) => {
              if (item.title === "StockBank") {
                return (
                  <div key={index}>
                    <div className={styled.modalContainer1}>
                      <p className={styled.title}>hospital name</p>
                      <div className={styled.line}></div>
                      <p className={styled.content}>{item.name}</p>
                    </div>
                    <div className={styled.modalContainer1}>
                      <p className={styled.title}>hospital address</p>
                      <div className={styled.line}></div>
                      <p className={styled.content}>{item.address}</p>
                    </div>
                    <div className={styled.modalContainer1}>
                      <p className={styled.title}>order time</p>
                      <div className={styled.line}></div>
                      <p className={styled.content}>
                        {constructOrderDate(item.tym)}
                      </p>
                    </div>
                  </div>
                );
              } else {
                return null; // If title is not "StockBank", render nothing
              }
            })}
          </div>
          <div className="d-flex justify-content-center mt-3">
            <button
              className={` shadow-none ${styled.actionBtn} ${styled.reject}`}
              style={{ background: color() }}
              onClick={processHandler}
            >
              {loading ? <SyncOutlined spin /> : `SEND TO VENDOR`}
            </button>
          </div>
        </div>
      </div>

      <Reason reason={reason} setReason={setReason} />
      <DeclineFlag flag={flag} setFlag={setFlag} />
    </>
  );
};

export default StockItems;
